// extracted by mini-css-extract-plugin
module.exports = {"list":"TourList_list__2dSMo","badges":"TourList_badges__incgR","load":"TourList_load__1nDQg"};